<button #buttonElement
    [ngClass]="buttonClasses"
    [ngStyle]="buttonStyles"
    [type]="type"
    [disabled]="isButtonDisabled || loading"
    [attr.aria-label]="ariaLabel || label || text"
    [attr.aria-disabled]="isButtonDisabled || loading"
    [attr.aria-busy]="loading"
    [attr.tabindex]="tabindex"
    [autofocus]="autofocus"
    (click)="handleClick($event)"
    (keydown)="handleKeyDown($event)"
    (focus)="handleFocus($event)"
    (blur)="handleBlur($event)"
    [@buttonPress]="buttonState">
    
    <!-- Ripple Effect -->
    <span *ngIf="ripple"
          class="ni-btn-ripple"
          [style.left.px]="ripple.x"
          [style.top.px]="ripple.y"
          [style.width.px]="ripple.size"
          [style.height.px]="ripple.size">
    </span>
    
    <span 
      class="relative z-10 flex flex-row items-center gap-2"
      [ngClass]="{
        'justify-center': (!label && !text && (leadingIcon || trailingIcon || icon)) || (!getDisplayIcons().leading && !getDisplayIcons().trailing),
        'justify-between': (getDisplayIcons().leading || getDisplayIcons().trailing) && (label || text)
      }">
      
      <!-- Loading Spinner -->
      <ng-container *ngIf="loading">
        <div class="ni-btn-spinner w-5 h-5 border-2 border-current border-t-transparent rounded-full"></div>
      </ng-container>
      
      <!-- Leading Icon -->
      <ng-container *ngIf="getDisplayIcons().leading && !loading">
        <span class="inline-flex cursor-pointer">
          <NiIcon 
            [icon]="getDisplayIcons().leading" 
            [iconClass]="leadingIconClass"
            (onClick)="handleLeadingIconClick($event)">
          </NiIcon>
        </span>
      </ng-container>
      
      <!-- Label/Text -->
      <span *ngIf="getDisplayText()">
        {{ getDisplayText() }}
      </span>
      
      <!-- Trailing Icon -->
      <ng-container *ngIf="getDisplayIcons().trailing && !loading && (label || text)">
        <span class="inline-flex cursor-pointer">
          <NiIcon 
            [icon]="getDisplayIcons().trailing" 
            [iconClass]="trailingIconClass"
            (onClick)="handleTrailingIconClick($event)">
          </NiIcon>
        </span>
      </ng-container>
      
      <!-- Badge (Legacy Support) -->
      <span *ngIf="badge" 
            class=" px-2 py-0.5 rounded-full text-xs font-semibold"
            [ngClass]="badgeColorClass + ' ' + badgeClass"
            [ngStyle]="badgeStyles">
        {{ badge }}
      </span>
    </span>
</button>